// Union-of-used replacement for the @directv-digital/fusion.atoms.icons BARREL.
//
// Why: the icons package ships 86 per-icon ESM files behind one barrel, which
// @directv-digital dist packages consume via CJS require() (9 pkgs) and ESM
// import (several more). The CJS requires defeat webpack tree-shaking — every
// route bundled all 86 icons (~478 kB raw / ~175 kB gz in the fusion-icons
// chunk, plus duplicated copies in other chunks). next.config.js aliases the
// EXACT package specifier ('...fusion.atoms.icons$') to this file, so every
// barrel import — ESM or CJS — resolves to this union-of-used re-export list
// instead. Deep '/dist/components/*' imports are unaffected (they fall
// through to the real package via the prefix alias).
//
// Maintenance: this list must contain every icon imported through the BARREL
// anywhere in the client graph (UF src/app AND @directv-digital packages).
// A missed icon fails the production build (dev: compile error) via two
// guards in next.config.js: IconShimGuard promotes webpack's "not exported"
// warnings to errors (covers ESM imports), and
// config/fusion-icons-check.js scans the dists' CJS member accesses (webpack
// emits no warning for those). To add an icon: copy the matching line from
// the real package's dist/index.js and prefix the path, as below.
//
// PERMANENT — do not plan on deleting this. An earlier version of this note
// said to remove the file, the alias, and both guards "once the consumers
// import per-icon paths upstream". That upstream fix is impossible. bit refuses
// to tag any component that imports a bit-component dependency's non-main
// files (component issue ImportNonMainFiles, "Is Tag/Snap blocker: yes").
// Converting the 8 dds.ui consumers to per-icon deep imports was tried in
// video-lab PR #2791 and it broke the DDS publish pipeline for the whole repo:
// Jenkins build #33 failed at "Bit Tag and Export" with those 8 components
// flagged plus 100 dependents pending auto-tag, so nothing published at all.
// Reverted in PR #2838.
//
// A follow-up spike ruled out every packaging workaround on the icons package:
// an `exports` map does not satisfy the check, and neither does a nested
// package.json, because bit judges the FINAL RESOLVED FILE — routing through
// another entry point still lands on dist/components/<icon>.js. The check only
// applies to bit-component dependencies, which is why @mui/material/* deep
// imports sit un-flagged in the very same files. The only conforming per-icon
// design would split the icons package into ~86 separate bit components, and
// that saves 0 kB over this shim.
//
// So this shim is the fix, not a stopgap. It already delivered the entire win:
// fusion-icons chunk 478 -> 75 kB raw (175 -> 27 kB gz, -84%), home First Load
// 715 -> 566 kB. Keep it, and keep both guards with it.
export { AddMaximizeIcon } from "@directv-digital/fusion.atoms.icons/dist/components/addMaximize";
export { AlertIcon } from "@directv-digital/fusion.atoms.icons/dist/components/alert";
export { ApprovalIcon } from "@directv-digital/fusion.atoms.icons/dist/components/approval";
export { BadgeAlertIcon } from "@directv-digital/fusion.atoms.icons/dist/components/badgeAlert";
export { CheckIcon } from "@directv-digital/fusion.atoms.icons/dist/components/check";
export { CloseIcon } from "@directv-digital/fusion.atoms.icons/dist/components/close";
export { DownIcon } from "@directv-digital/fusion.atoms.icons/dist/components/down";
export { DVRIcon } from "@directv-digital/fusion.atoms.icons/dist/components/dvr";
export { ErrorIcon } from "@directv-digital/fusion.atoms.icons/dist/components/error";
export { FavouriteChnlIcon } from "@directv-digital/fusion.atoms.icons/dist/components/favouriteChnl";
export { InfoCircleIcon } from "@directv-digital/fusion.atoms.icons/dist/components/infoCircle";
export { LeftIcon } from "@directv-digital/fusion.atoms.icons/dist/components/left";
export { PlayIcon } from "@directv-digital/fusion.atoms.icons/dist/components/play";
export { PauseIcon } from "@directv-digital/fusion.atoms.icons/dist/components/pause";
export { MagnifyingGlassIcon } from "@directv-digital/fusion.atoms.icons/dist/components/magnifyingGlass";
export { OfferIcon } from "@directv-digital/fusion.atoms.icons/dist/components/offer";
export { OptionsOffIcon, OptionsOnIcon } from "@directv-digital/fusion.atoms.icons/dist/components/options";
export { ShowPasswordIcon, HidePasswordIcon } from "@directv-digital/fusion.atoms.icons/dist/components/password";
export { RightIcon } from "@directv-digital/fusion.atoms.icons/dist/components/right";
export { ShoppingCartIcon } from "@directv-digital/fusion.atoms.icons/dist/components/shoppingCart";
export { SubtractMinimizeIcon } from "@directv-digital/fusion.atoms.icons/dist/components/subtractMinimize";
export { UpIcon } from "@directv-digital/fusion.atoms.icons/dist/components/up";
export { BusinessSupportIcons } from "@directv-digital/fusion.atoms.icons/dist/components/businessSupport";
